import { format, parseISO  } from 'date-fns';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import { Scrollbar } from 'src/components/scrollbar';

const statusMap = {
  pending: 'warning',
  delivered: 'success',
  refunded: 'error'
};

export const OverviewLatestCustomers = (props) => {
  const { customers = [], sx } = props;

  return (
    <Card sx={sx}>
      <CardHeader title="Latest Customers" />
      <Scrollbar sx={{ flexGrow: 1 }}>
        <Box sx={{ minWidth: 800 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  Full Name
                </TableCell>
                <TableCell>
                  Email
                </TableCell>
                <TableCell sortDirection="desc">
                  Gender
                </TableCell>
                <TableCell>
                  Created At
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((customer) => {
                const parsedCreatedAt = parseISO(customer.created_at);
                const createdAt = format(parsedCreatedAt, 'yyyy-MM-dd HH:mm:ss');
                ;

                return (
                  <TableRow
                    hover
                    key={customer.id}
                  >
                    <TableCell>
                      {customer.full_name}
                    </TableCell>
                    <TableCell>
                      {customer.email}
                    </TableCell>
                    <TableCell>
                      {customer.gender}
                    </TableCell>
                    <TableCell>
                      {createdAt}
                    </TableCell>
                   
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      </Scrollbar>
      <Divider />
    </Card>
  );
};

OverviewLatestCustomers.prototype = {
  customers: PropTypes.array,
  sx: PropTypes.object
};
